import { ThemingConfig } from '@chakra-ui/react';

const colors: ThemingConfig['tokens'] = {
  colors: {
    arctic: {
      50: { value: '#F4FCFC' },
      100: { value: '#E0EEF5' },
      200: { value: '#CDDDE5' },
      300: { value: '#B2CAD7' },
      400: { value: '#8DB1C3' },
      500: { value: '#5B8FA9' },
      600: { value: '#406676' },
      700: { value: '#1A3E50' },
      750: { value: '#0D3244' },
      800: { value: '#00293C' },
      900: { value: '#051E2A' },
    },
    mint: {
      50: { value: '#E6F9F9' },
      100: { value: '#C5F2F2' },
      200: { value: '#95E5E3' },
      300: { value: '#68D9D7' },
      400: { value: '#3ED1CD' },
      500: { value: '#00C7BE' },
      600: { value: '#009B96' },
      700: { value: '#006769' },
      800: { value: '#003B3E' },
      900: { value: '#00252D' },
    },
    quasar: {
      100: { value: '#FFDCBD' },
      300: { value: '#FFC28A' },
      500: { value: '#F7BA82' },
      600: { value: '#E6AB74' },
      700: { value: '#B47841' },
    },
    lightGray: {
      80: { value: '#F2F2F2' },
      100: { value: '#EFEEEF' },
    },
    blue: {
      10: { value: '#F1F8FC' },
    },
    primary: {
      50: { value: '#eaf8ff' },
      100: { value: '#d6f1ff' },
      200: { value: '#ace2fe' },
      300: { value: '#83d4fe' },
      400: { value: '#59c5fd' },
      500: { value: '#30B7FD' },
      600: { value: '#2692ca' },
      700: { value: '#1d6e98' },
      800: { value: '#134965' },
      900: { value: '#0a2533' },
    },
    secondary: {
      50: { value: '#fef0e9' },
      100: { value: '#fce2d3' },
      200: { value: '#fac5a7' },
      300: { value: '#f7a77b' },
      400: { value: '#f58a4f' },
      500: { value: '#f26d23' },
      600: { value: '#c2571c' },
      700: { value: '#F4F7F9' },
      800: { value: '#092B49' },
      900: { value: '#301607' },
    },
    tertiary: {
      50: { value: '#f9e9ea' },
      100: { value: '#f3d2d6' },
      200: { value: '#e6a5ad' },
      300: { value: '#da7983' },
      400: { value: '#cd4c5a' },
      500: { value: '#c11f31' },
      600: { value: '#9a1927' },
      700: { value: '#74131d' },
      800: { value: '#4d0c14' },
      900: { value: '#27060a' },
    },
    gray: {
      20: { value: '#DEDEE0' },
      25: { value: '#f9f9f9' },
      50: { value: '#eff0f1' },
      75: { value: '#f2f2f2' },
      100: { value: '#dee0e2' },
      200: { value: '#ced1d4' },
      300: { value: '#bdc2c6' },
      400: { value: '#adb3b8' },
      500: { value: '#9da3a9' },
      600: { value: '#8c949b' },
      700: { value: '#7c858d' },
      800: { value: '#6b757e' },
      900: { value: '#5b6670' },
    },
    navy: {
      50: { value: '#b5bfc8' }, // @TODO Bad color, update this
      100: { value: '#9daab6' },
      200: { value: '#6b8092' },
      300: { value: '#3a556d' },
      400: { value: '#113656' },
      500: { value: '#092b49' },
      600: { value: '#07223a' },
      700: { value: '#051a2c' },
      800: { value: '#04111d' },
      900: { value: '#02090f' },
    },
    // NEW DESIGNS
    brandPrimary: {
      50: { value: '#ffffff' },
      100: { value: '#e9f6ff' },
      200: { value: '#d1edff' },
      300: { value: '#7ccbff' },
      400: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
      500: { value: '#a7e1ff' },
      600: { value: '#2ba0e3' },
      700: { value: '#005e99' },
      800: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
    },
    brandPrimaryDark: {
      50: { value: '#021420' },
      100: { value: '#162636' },
      200: { value: '#153243' },
      300: { value: '#1e4d66' },
      400: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
      500: { value: '#3bb8ff' },
      600: { value: '#48c4ff' },
      700: { value: '#8fd6ff' },
      800: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
    },
    brandSecondary: {
      50: { value: '#ffffff' },
      100: { value: '#f4f7fa' },
      200: { value: '#d9e0e8' },
      300: { value: '#3a5e80' },
      400: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
      500: { value: '#a5c8e6' },
      600: { value: '#092b49' },
      700: { value: '#092f4a' },
      800: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
    },
    brandSecondaryDark: {
      50: { value: '#ffffff' },
      100: { value: '#0a1521' },
      200: { value: '#123047' },
      300: { value: '#23577a' },
      400: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
      500: { value: '#3b7ba6' },
      600: { value: '#1f4d7e' },
      700: { value: '#b9ddfa' },
      800: { value: '#ff00fb' }, // @TODO Missing color if you see pink youll know why
    },
    brandText: {
      fg: { value: '#000000' },
    },
    brandTextDark: {
      fg: { value: '#ffffff' },
    },
    brandSurface: {
      bg: { value: '#e0ebf5' },
      deepRecess: { value: '#c5d0e5' },
      recessed: { value: '#f2f6fc' },
    },
    brandSurfaceDark: {
      bg: { value: '#080c12' },
      deepRecess: { value: '#1f314d' },
      recessed: { value: '#0e1521' },
    },
    brandBorder: {
      branded: { value: '#d6e1eb' },
      brandedSubtle: { value: '#e4edf5' },
    },
    brandBorderDark: {
      branded: { value: '#192d3d' },
      brandedSubtle: { value: '#162430' },
    },
  },
};

export default colors;
